<template>
  <div class="">
    <v-card-title class="px-0 text-h6">Interpretation by {{ getAuthors }} first published on {{ suggestedInterpretation.date }}</v-card-title>
    <div id="annotation" class="py-4" v-html="suggestedInterpretation.suggestedInterpretation" ></div>
    <v-card-text v-if="suggestedInterpretation.modifiedOn !== ''"> (Last modified on {{ suggestedInterpretation.modifiedOn }})</v-card-text>
  </div>
</template>
<script>

export default {
  name: 'SuggestedInterpretation',
  components: {
  },
  props: {
    suggestedInterpretation:{},
  },
  data () {
    return {
    }
  },
  computed: {
    getAuthors(){
      let authorNames = ""
      let authorNamesListID = 0
      for (let author of this.suggestedInterpretation.authorList){
        authorNamesListID += 1
        if (this.suggestedInterpretation.authorList.length > 1){
          if (authorNamesListID === this.suggestedInterpretation.authorList.length){
            authorNames += " and "
          } else {
            if (authorNamesListID > 1){
              authorNames += ", "
            }
          }
        }
        authorNames += author.firstname + " " + author.lastname
      }

      return authorNames
    },
  },
  methods: {
  },
  watch: {
    'suggestedInterpretation': function(newVal, oldVal) {
    },
  },
  mounted:function () {
    console.log("suggestedInterpretation", this.suggestedInterpretation)
    console.log("suggestedInterpretation date", this.suggestedInterpretation.date)
  },
  beforeUpdate:function () {
  }
}
</script>

<style lang="css" >
</style>
